"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveUsersToGroupSaveSuccess = exports.moveUsersToGroupSaveFailure = exports.moveUsersToGroupSaveRequest = exports.moveUserToGroup = exports.toggleMoveUserToGroup = exports.clearState = exports.UsergroupInvite = exports.UsergroupList = void 0;
const ActionTypes = require("../../actionTypes/customer/members");
const _usergroupInvite = require("../../modules/usergroup/invite/actions");
const _usergroupList = require("../../modules/usergroup/list/actions");
exports.UsergroupList = _usergroupList.default('customer/members');
exports.UsergroupInvite = _usergroupInvite.default('customer/members');
const clearState = () => ({
    type: ActionTypes.CLEAR_STATE
});
exports.clearState = clearState;
//#region move
const toggleMoveUserToGroup = (open) => ({
    type: ActionTypes.TOGGLE_MOVE_USER_TO_GROUP,
    open
});
exports.toggleMoveUserToGroup = toggleMoveUserToGroup;
const moveUserToGroup = (users) => ({
    type: ActionTypes.MOVE_USER_TO_USER_GROUP,
    payload: {
        users
    }
});
exports.moveUserToGroup = moveUserToGroup;
const moveUsersToGroupSaveRequest = (users, group) => ({
    type: ActionTypes.MOVE_USER_TO_USER_GROUP_SAVE_REQUEST,
    payload: {
        users,
        group
    }
});
exports.moveUsersToGroupSaveRequest = moveUsersToGroupSaveRequest;
const moveUsersToGroupSaveFailure = (error) => ({
    type: ActionTypes.MOVE_USER_TO_USER_GROUP_SAVE_FAILURE,
    data: {
        error
    }
});
exports.moveUsersToGroupSaveFailure = moveUsersToGroupSaveFailure;
const moveUsersToGroupSaveSuccess = () => ({
    type: ActionTypes.MOVE_USER_TO_USER_GROUP_SAVE_SUCCESS
});
exports.moveUsersToGroupSaveSuccess = moveUsersToGroupSaveSuccess;
//#endregion
//# sourceMappingURL=members.js.map